import Component from './component'
import { connect } from 'react-redux';
import {adicionarImagem, deletarImagem, modificarDescImagem} from '../../../actions/imagem'

const mapStateToProps = (state) => {
    return {
      imagens: state.database.imagens.map(obj => obj? obj.toObject() : undefined)
    }
  }

const mapDispatch = dispatch =>({
    adicionarImagem : (img, desc)=> dispatch(adicionarImagem(img, desc)),
    deletarImagem : (id) => dispatch(deletarImagem(id)),
    editarImagem : (id, desc) => dispatch(modificarDescImagem(id, desc))
})

export default connect(mapStateToProps, mapDispatch)(Component)


// WEBPACK FOOTER //
// ./src/views/administrativo/imagens/container.js